import { Partial } from '@40seas/entities/common';
import { WiseTransfer } from './wise.transfer.entity';

export class UpdateWiseTransferDto extends Partial(WiseTransfer) {}
